import React, { useEffect, useState } from "react";
import { CrudModal } from "../../components/_index";
import { Formik, Form, Field } from "formik";
import Grid from "@mui/material/Grid2";
import {
  Typography,
  Button,
  Box,
  Checkbox,
  TextField,
  Divider,
  Autocomplete,
} from "@mui/material";
import { AutoComplete, DatePicker } from "../../components/_index";
import * as yup from "yup";
import { useDispatch } from "react-redux";
import { showToast } from "../../redux/Reducer/toastReducer";
import {
  getCategory,
  postCategory,
  updateCategory,
  getRole,
} from "../../services/category.service";
import { FileUploader } from "react-drag-drop-files";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import { updateTicket } from "../../services/ticket.service";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import { getSpecificUser, getUser } from "../../services/user.service";

const isValidUserToShowCategory = () => {
  let role = localStorage.getItem("role");
  console.log("role: ", role);
  if (["HR", "PROJECT MANAGER"].includes(role)) {
    return true;
  }
  return false;
};

const AssignRequest = ({
  handleCloseDrawer,
  formType,
  selectedData,
  setOpenDrawer,
  GetTicketData,
  reassign,
  reassignUser,
}) => {
  const dispatch = useDispatch();
  console.log("selectedDataaaaaaa", selectedData);
  console.log("reassignUserreassignUser", reassignUser);
  const disabled = formType === "edit";
  const [categoryData, setCategoryData] = useState([]);
  const [departmentRoleId, selectedDataRoleId] = useState(
    selectedData.assignedDepartmentId
  );
  const [userData, setUserData] = useState([]);
  const [department, setDepartment] = useState([]);

  const [warningMessage, setWarningMessage] = useState("");
  const [roleName, setRoleName] = useState(selectedData?.roleName || "");

  const [initialValues, setInitialValues] = useState({
    categoryId: "",
    subject: "",
    message: "",
    mode: "",
    assignedTo: "",
    file: [],
  });
  const documentFile = selectedData?.replyMessages[0]?.documents[0];
  const [checked, setChecked] = useState(false);
  const validationSchema = yup.object().shape({
    // categoryId: yup.string().required("Category Required *"),
    subject: yup.string().required("Enter the subject *"),
    message: yup.string().required("Enter the message *"),
    assignedTo: yup.string().required("Select the Assignee"),
  });
  const findDeptByUserId = (roleShortName) => {
    if (!roleShortName) return [];
    if (roleShortName == "FEEDBACK-ADMIN"||roleShortName=="Management") {
      roleShortName = "Admin";
    }
    if (roleShortName == "PROJECT MANAGER") {
      roleShortName = "PM";
    }
    if (roleShortName == "IT SUPPORT") {
      roleShortName = "IT Support";
    }

    // Get users for the selected role short name (PM, HR, etc.)
    return (
      userData[roleShortName]?.map((ele) => ({ ...ele, label: ele?.name })) ||
      []
    );
  };

  console.log(roleName, "_____________|");
  const GetCategoryDatas = async () => {
    try {
      const res = await getRole();
      const modifiedData =
        res?.data
          .filter(
            (e) =>
              e.name === "HR" ||
              e.name === "PROJECT MANAGER" ||
              e.name === "FEEDBACK-ADMIN" ||
              e.name === "IT SUPPORT"
          )
          .map((e) => ({
            ...e,
            label: e.shortName,
            id: e._id,
          })) || [];
      setDepartment(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    selectedData?.replyMessages[selectedData?.replyMessages?.length - 1]
      ?.isAutoGenerated
      ? setWarningMessage(
          "The ticket conversation is already in a warning state. Are you sure you want to proceed with reassignment?"
        )
      : setWarningMessage("");
    if (formType === "edit" || formType === "view") {
      setInitialValues({
        ticketId: selectedData?.ticketId || "",
        createdAtDate: selectedData?.createdAt || "",
        ticketCreatedName: selectedData?.createdByName || "",
        ticketCreatedEmail: selectedData?.createdByEmail
          ? selectedData?.createdByEmail
          : "" || selectedData?.email || "",
        categoryId: selectedData?.categoryId || "",
        assignedTo: selectedData?.assignedToInfo?._id || "",
        subject: selectedData.subject || "",
        mode: selectedData.modeType || "",
        project: selectedData?.createdByInfo?.projectName || "",
        department: selectedData?.department || "",
        others: selectedData?.otherOption || " ",
        assignedDepartmentId: selectedData.assignedDepartmentId || "",
        message:
          selectedData.replyMessages[0].message ||
          selectedData?.firstMessage ||
          "",
      });
    }
  }, [formType, selectedData]);

  React.useEffect(() => {
    if (departmentRoleId) {
      getCategory({ departmentRoleId }).then((res) => {
        const modifiedData = res.data.map((el) => ({
          ...el,
          label: el?.name,
        }));
        setCategoryData(modifiedData);
      });
    }
  }, [departmentRoleId]);

  useEffect(() => {
    GetCategoryDatas();
    getSpecificUser().then((res) => {
      const modifiedData = res.data.reduce((acc, el) => {
        const shortName = el?.roleData?.shortName;

        if (!acc[shortName]) {
          acc[shortName] = [];
        }

        acc[shortName].push({
          ...el,
          label: `${el?.name}`,
        });

        return acc;
      }, {});
      // console.log("modifedData: ", modifiedData);
      setUserData(modifiedData);

      // const parsedDeparmentData = Array.from(
      //   new Map(
      //     res.data.data.map((el) => [
      //       `${el?.roleData?.shortName}`,
      //       {
      //         ...el,
      //         label: `${el?.roleData?.shortName}`,
      //         id: `${el?.roleData?.shortName}`,
      //       },
      //     ])
      //   ).values()
      // );
      // // console.log("parsedDepartmentData: ", parsedDeparmentData);
      // setDepartment(parsedDeparmentData);
    });
  }, []);

  const [fileName, setFileName] = useState(
    selectedData.documentFile ? selectedData?.documentFile?.fileName : ""
  );

  const voiceName = selectedData?.voiceFile?.fileName;
  //   const maxLength = 15; // Adjust the maximum length to your preference
  //   const shortenedName =
  //     voiceName && voiceName.length > maxLength
  //       ? voiceName.substring(0, maxLength) + "..."
  //       : voiceName;

  const handleFileChange = (e, file, setFieldValue) => {
    if (e && e.name) {
      const selectedFile = e;
      setFileName(selectedFile.name);
      setFieldValue(file, selectedFile);
    }
  };

  const onSubmit = async (values) => {
    try {
      console.log(values,"________________")
      const userId = localStorage.getItem("userId");
      const formWithManager = {
        assignedTo: values.assignedTo,
        assignedBy: userId,
        assignedDepartmentId: values?.assignedDepartmentId,
        project: values?.project,
        categoryId: values?.categoryId,
        department:
          values?.department == "Admin" ? "Management" : values?.department,
        // isReAssigned:true
      };

      if (reassignUser) {
        formWithManager.isReAssigned = false;
      }

      //   const formData = new FormData();

      //   formData.append("values", JSON.stringify(formWithManager));
      //   if (values.file) {
      //     formData.append("file", values.file);
      //   }

      const apiMethod =
        formType === "edit"
          ? updateTicket(selectedData._id, formWithManager).then((res) => {
              GetTicketData();
              dispatch(
                showToast({
                  message: `Ticket Assigned Successfully`,
                  type: "success",
                })
              );
            })
          : postCategory(formWithManager);
      const res = await apiMethod;
      setOpenDrawer(false);

      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      dispatch(showToast({ message: error.data.message, type: "error" }));
    }
  };

  return (
    <CrudModal
      title={
        // formType === "add"
        //   ? "Create Ticket"
        //   : formType === "edit"
        //   ? "Edit Ticket"
        //   : "View Ticket"
        reassign === true ? "Re Assignee" : "Assignee"
      }
      open={true}
      handleClose={handleCloseDrawer}
      maxWidth={reassign === true ? "xs" : "md"}
    >
      {reassign === true ? (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          // validationSchema={validationSchema}
        >
          {({ touched, errors, setFieldValue, values }) => (
            <div className="formContainer" style={{ height: "fit-content" }}>
              <Form>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Department
                    </Typography>
                    <AutoComplete
                      options={department}
                      value={values?.assignedDepartmentId}
                      getOptionLabel={(option) => option.label}
                      onChange={(e, v) => {
                        setRoleName(v?.label);
                        setFieldValue("assignedDepartmentId", v?._id || "");
                        setFieldValue("assignedTo", ""); // Reset assignee when department changes
                        setFieldValue("department", v?.label || "");
                      }}
                      placeholder="Select Department to assign"
                    />
                    <div className="form-error">
                      {touched.assignedDepartmentId &&
                      errors.assignedDepartmentId
                        ? errors.assignedDepartmentId
                        : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Name of the Assignee
                    </Typography>
                    <AutoComplete
                      options={findDeptByUserId(roleName) || []}
                      clearIcon={false}
                      // value={values?.assignedTo}

                      value={values?.assignedTo}
                      onChange={(e, v) => {
                        setFieldValue("assignedTo", v ? v._id : null); 
                      }}
                      placeholder="Select user to assign"
                    />
                    <div className="form-error">
                      {touched.assignedTo && errors.assignedTo
                        ? errors.assignedTo
                        : null}
                    </div>
                  </Grid>
                  {warningMessage && (
                    <Grid size={{ xs: 12, sm: 12 }}>
                      <Typography sx={{ color: "red", fontSize: "10px" }}>
                        {warningMessage}
                      </Typography>
                    </Grid>
                  )}

                  <Grid size={{ xs: 12 }} mt={2}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "20px",
                      }}
                    >
                      <Button
                        className="cancelButton"
                        onClick={() => setOpenDrawer(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="addButton"
                        // sx={{ display: formType === "view" ? "none" : "flex" }}
                      >
                        Re Assign
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </div>
          )}
        </Formik>
      ) : (
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ touched, errors, setFieldValue, values }) => (
            <div className="formContainer" style={{ height: "fit-content" }}>
              <Form>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Ticket ID
                    </Typography>
                    <Field
                      name="ticketId"
                      className="InputField"
                      placeholder="Enter Category"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.ticketId && errors.ticketId
                        ? errors.ticketId
                        : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Received Date {/* CreatedAt */}
                    </Typography>
                    <Field
                      name="createdAtDate"
                      className="InputField"
                      placeholder="Enter Category"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.createdAtDate && errors.createdAtDate
                        ? errors.createdAtDate
                        : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Employee Name {/* Creator's Name */}
                    </Typography>
                    <Field
                      name="ticketCreatedName"
                      className="InputField"
                      placeholder="Enter Category"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.ticketCreatedName && errors.ticketCreatedName
                        ? errors.ticketCreatedName
                        : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Employee Email {/* Creator's Email */}
                    </Typography>
                    <Field
                      name="ticketCreatedEmail"
                      className="InputField"
                      placeholder="Enter Created Email"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.ticketCreatedEmail && errors.ticketCreatedEmail
                        ? errors.ticketCreatedEmail
                        : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Mode
                    </Typography>
                    <Field
                      name="mode"
                      className="InputField"
                      placeholder="Enter Mode"
                      disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.mode && errors.mode ? errors.mode : null}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography>Project</Typography>
                    <Field
                      name="project"
                      className="InputField"
                      placeholder="Enter the Project"
                      disabled={disabled}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <Typography>Department</Typography>
                    <Field
                      name="department"
                      className="InputField"
                      placeholder="Enter the Department"
                      disabled={disabled}
                    />
                  </Grid>
                  {selectedData?.otherOption && (
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Typography>Others</Typography>
                      <Field
                        name="others"
                        className="InputField"
                        placeholder="Enter the Others"
                        disabled={disabled}
                      />
                    </Grid>
                  )}
                  <Grid size={12}>
                    <Divider
                      sx={{
                        borderStyle: "dotted",
                        borderColor: "#ccc",
                        borderBottomWidth: "1px",
                        my: 2,
                      }}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Subject
                    </Typography>
                    <Field
                      name="subject"
                      className="InputField"
                      placeholder="Enter Subject"
                      // disabled={disabled}
                      // disabled={disabled}
                    />
                    <div className="form-error">
                      {touched.subject && errors.subject
                        ? errors.subject
                        : null}
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Message
                    </Typography>
                    <div
                      // contentEditable={!disabled}
                      contentEditable={true}
                      dangerouslySetInnerHTML={{ __html: values.message }}
                      onInput={(e) => {
                        const html = e.currentTarget.innerHTML;
                        setFieldValue("message", html);
                      }}
                      style={{
                        minHeight: "100px",
                        padding: "5px 10px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        overflowY: "auto",
                        whiteSpace: "pre-wrap",
                        // pointerEvents: disabled ? "none" : "auto", // disables all interactions
                      }}
                    />

                    {/* <Field
                      name="message"
                      component={TextField}
                      placeholder="Enter Message"
                      disabled={disabled}
                      value={values.message}
                      // component={props => <div dangerouslySetInnerHTML={{ __html: props.value }} />}
                      multiline
                      rows={4}
                      fullWidth
                      sx={{
                        "& .MuiInputBase-root": {
                          padding: 0,
                        },
                        "& textarea": {
                          padding: "5px 10px",
                          boxSizing: "border-box",
                          width: "100%",
                          "&::-webkit-scrollbar": {
                            width: "8px",
                          },
                          "&::-webkit-scrollbar-thumb": {
                            backgroundColor: "#888",
                            borderRadius: "60px",
                          },
                          scrollbarWidth: "thin",
                        },
                      }}
                    /> */}

                    <div className="form-error">
                      {touched.message && errors.message
                        ? errors.message
                        : null}
                    </div>
                  </Grid>
                  {documentFile?.fileUrl ? (
                    <Grid size={{ xs: 12, sm: 6 }}>
                      <Typography
                        className="inputTitle"
                        sx={{ fontSize: "12px" }}
                      >
                        File
                      </Typography>
                      <Grid
                        // mt={2}
                        sx={{
                          cursor: "pointer",
                          display: "flex",
                          gap: 2,
                          height: "38px",
                          alignItems: "center",
                          padding: "10px",
                          paddingLeft: "50px",
                          border: "1px solid #e0e0e0",
                          borderRadius: "8px",
                          backgroundColor: "#f9f9f9",
                          boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
                          transition:
                            "background-color 0.3s ease, box-shadow 0.3s ease",
                          ":hover": {
                            backgroundColor: "#e1f5f2",
                            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.15)",
                          },
                        }}
                      >
                        <CloudUploadOutlinedIcon sx={{ color: "#00675d" }} />
                        <Typography
                          style={{
                            cursor: "pointer",
                            color: "#00675d",
                            fontSize: "14px",
                            fontWeight: "500",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            maxWidth: "calc(100% - 30px)", // to prevent overflow
                          }}
                          onClick={() => {
                            if (documentFile?.fileUrl) {
                              window.open(documentFile.fileUrl, "_blank");
                            } else {
                              console.log("No URL provided.");
                            }
                          }}
                        >
                          {documentFile?.fileName?.length > 35
                            ? `${documentFile.fileName.substring(0, 35)}...`
                            : documentFile?.fileName}
                        </Typography>
                      </Grid>
                    </Grid>
                  ) : (
                    <Grid size={{ xs: 12, sm: 6 }} />
                  )}
                  {/* <Grid size={{ xs: 12, sm: 6 }} /> */}
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Department
                    </Typography>
                    <Autocomplete
                      options={department}
                      getOptionLabel={(option) => option?.label || ""}
                      value={
                        department.find(
                          (dept) => dept._id === values?.assignedDepartmentId
                        ) || {
                          _id: "default",
                          label: selectedData?.department,
                        }
                      }
                      onChange={(e, v) => {
                        setFieldValue("assignedDepartmentId", v?._id || "");
                        selectedDataRoleId(v?._id || "");
                        setRoleName(v?.label || "");
                      }}
                      isOptionEqualToValue={(option, value) =>
                        option._id === value._id
                      }
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Select Department to assign"
                        />
                      )}
                    />
                    <div className="form-error">
                      {touched.assignedDepartmentId &&
                      errors.assignedDepartmentId
                        ? errors.assignedDepartmentId
                        : null}
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Category
                    </Typography>
                    <AutoComplete
                      disabled={null}
                      onChange={(e, v) => setFieldValue("categoryId", v?._id)}
                      options={categoryData}
                      placeholder="Select Category"
                      value={values?.categoryId}
                    />

                    <div className="form-error">
                      {touched.categoryId && errors.categoryId
                        ? errors.categoryId
                        : null}
                    </div>
                  </Grid>

                  <Grid size={{ xs: 12, sm: 12 }}>
                    <Typography
                      className="inputTitle"
                      sx={{ fontSize: "12px" }}
                    >
                      Name of the Assignee
                    </Typography>
                    <AutoComplete
                      options={findDeptByUserId(roleName) || []}
                      clearIcon={false}
                      // value={values?.assignedTo}
                      value={values?.assignedTo}
                      onChange={(e, v) => {
                        setFieldValue("assignedTo", v ? v._id : null);
                      }}
                      placeholder="Select user to assign"
                    />
                    <div className="form-error">
                      {touched.assignedTo && errors.assignedTo
                        ? errors.assignedTo
                        : null}
                    </div>
                  </Grid>

                  {/* <Grid size={{ xs: 12, sm: 6 }}>
                <Typography
                  className="InputTitle"
                  sx={{ marginBottom: "-2px" }}
                >
                  &nbsp;
                </Typography>
                {selectedData?.documentFile && (
                  <RemoveRedEyeIcon
                    sx={{
                      padding: "6px",
                      border: "1px solid #D5D7E8",
                      borderRadius: "5px",
                      color: "#00675D",
                      cursor: "pointer",
                    }}
                    onClick={() =>
                      selectedData?.documentFile?.fileURL &&
                      window.open(selectedData?.documentFile?.fileURL)
                    }
                  />
                )}
              </Grid> */}
                  <Grid size={{ xs: 12 }} mt={2}>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "flex-end",
                        gap: "20px",
                      }}
                    >
                      <Button
                        className="cancelButton"
                        onClick={() => setOpenDrawer(false)}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="submit"
                        className="addButton"
                        // sx={{ display: formType === "view" ? "none" : "flex" }}
                      >
                        {formType === "edit" ? "Assign" : "Assign"}
                      </Button>
                    </Box>
                  </Grid>
                </Grid>
              </Form>
            </div>
          )}
        </Formik>
      )}
    </CrudModal>
  );
};

export default AssignRequest;
